<template>
  <b-form-group
    label="Shadow Projection"
    label-for="projection-edit-toggle"
    class="mb-0"
  >
    <div class="projection-settings border rounded p-3 bg-light">
      <b-form-checkbox
        id="projection-edit-toggle"
        v-model="edit"
        @input="onChange"
      >
        Edit Mode
      </b-form-checkbox>

      <div class="mt-3">
        <div class="d-flex flex-wrap text-center justify-content-between">
          <div class="w-50 p-1">
            <b-button
              variant="outline-primary"
              size="sm"
              class="w-100 d-flex align-items-center justify-content-center"
              style="gap: 4px"
              @click="applyProjectionPattern(PRESETS.LEFT_BACK)"
            >
              <i
                class="bi bi-arrow-up-left-square-fill me-2 mt-0"
                style="margin-top: -2px!important;"
              />
              Left Back
            </b-button>
          </div>
          <div class="w-50 p-1">
            <b-button
              variant="outline-primary"
              size="sm"
              class="w-100 d-flex align-items-center justify-content-center"
              style="gap: 4px"
              @click="applyProjectionPattern(PRESETS.RIGHT_BACK)"
            >
              Right Back
              <i
                class="bi bi-arrow-up-right-square-fill"
                style="margin-top: -2px!important;"
              />
            </b-button>
          </div>
          <div class="w-50 p-1">
            <b-button
              variant="outline-primary"
              size="sm"
              class="w-100 d-flex align-items-center justify-content-center"
              style="gap: 4px"
              @click="applyProjectionPattern(PRESETS.LEFT_FRONT)"
            >
              <i
                class="bi bi-arrow-down-left-square-fill"
                style="margin-top: -2px!important;"
              />
              Left Front
            </b-button>
          </div>
          <div class="w-50 p-1">
            <b-button
              variant="outline-primary"
              size="sm"
              class="w-100 d-flex align-items-center justify-content-center"
              style="gap: 4px"
              @click="applyProjectionPattern(PRESETS.RIGHT_FRONT)"
            >
              Right Front
              <i
                class="bi bi-arrow-down-right-square-fill"
                style="margin-top: -2px!important;"
              />
            </b-button>
          </div>
        </div>
      </div>

      <b-form-group
        label="Fade"
        class="mt-3 mb-0"
      >
        <b-input-group>
          <b-input
            v-model.number="fade"
            :max="100"
            :min="0"
            type="range"
            @input="onChange"
          />
          <template #append>
            <b-input
              v-model.number="fade"
              :max="100"
              :min="0"
              type="number"
              @input="onChange"
            />
          </template>
        </b-input-group>
      </b-form-group>
    </div>
  </b-form-group>
</template>


<script>
const PRESETS = {
  LEFT_BACK: 'left-back',
  RIGHT_BACK: 'right-back',
  LEFT_FRONT: 'left-front',
  RIGHT_FRONT: 'right-front'
}
const DEFAULT_VALUE = {
    value: [0,0,0,0,0,0,0,0],
    edit: false,
    fade: 0,
};

export default {
  name: 'ShadowProjection',
  props: {
    target: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: 'change',
  data: () => {
    return {
      value: DEFAULT_VALUE.value,
      edit: DEFAULT_VALUE.edit,
      fade: DEFAULT_VALUE.fade,
      PRESETS,
    }
  },
  watch: {
    target: {
      handler (val) {
        const { edit, value, fade } = val?.shadow?.projection || DEFAULT_VALUE;

        this.edit = edit || false;
        this.value = Array.isArray(value) && value.length === 8
          ? value
          : [...DEFAULT_VALUE.value];
        this.fade = fade || 0;
      },
      immediate: true,
    },
  },
  methods: {
    onChange() {
      this.$emit('change', {
        enabled: true,
        edit: this.edit,
        value: this.value,
        fade: Number(this.fade) || 0,
        _normalized: true
      });
    },
    applyProjectionPattern(event) {
      if (!this.target) return;

      const skewX = 0.4;
      const skewY = 0.8;

      switch (event) {
        case PRESETS.LEFT_BACK: {
          this.value = [
            -skewX, skewY,
            -skewX, skewY,
            0, 0,
            0, 0
          ];
          break;
        }
        case PRESETS.RIGHT_BACK: {
          this.value = [
            skewX, skewY,
            skewX, skewY,
            0, 0,
            0, 0
          ];
          break;
        }
        case PRESETS.LEFT_FRONT: {
          this.value = [
            -skewX, skewY * 1.5,
            -skewX, skewY * 1.5,
            0, 0,
            0, 0
          ];
          break;
        }
        case PRESETS.RIGHT_FRONT: {
          this.value = [
            skewX, skewY * 1.5,
            skewX, skewY * 1.5,
            0, 0,
            0, 0
          ];
          break;
        }
      }

      this.onChange();
    }
  }
}
</script>
